<div class="{{appType}}-strip strip bg font">
    <div class="text__container" [innerHTML]="data.text" [ngClass]="data.style"></div>
</div>